var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCrypto(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 117,
    viewBox: "0 0 140 117",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M104.029 35.536C113.221 35.536 120.672 28.0287 120.672 18.768C120.672 9.50729 113.221 2 104.029 2C94.8373 2 87.386 9.50729 87.386 18.768C87.386 28.0287 94.8373 35.536 104.029 35.536Z",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.946 113.087C57.7984 113.087 73.892 96.8717 73.892 76.869C73.892 56.8664 57.7984 40.651 37.946 40.651C18.0936 40.651 2 56.8664 2 76.869C2 96.8717 18.0936 113.087 37.946 113.087Z",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.872 58.106H27.156V75.158H42.872C45.1332 75.158 47.3019 74.2597 48.9008 72.6608C50.4997 71.0619 51.398 68.8932 51.398 66.632C51.398 64.3708 50.4997 62.2021 48.9008 60.6032C47.3019 59.0043 45.1332 58.106 42.872 58.106Z",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.321 52.42V57.749M41.553 52.42V57.749M32.321 92.757V98.086M41.553 92.757V98.086M22.317 58.106H27.659M22.317 92.21H27.659M42.872 75.158H27.156V92.21H42.872C45.1332 92.21 47.3019 91.3117 48.9008 89.7128C50.4997 88.1139 51.398 85.9452 51.398 83.684C51.398 81.4228 50.4997 79.2541 48.9008 77.6552C47.3019 76.0563 45.1332 75.158 42.872 75.158Z",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M115.629 114.382C127.984 114.382 138 104.291 138 91.842C138 79.3935 127.984 69.302 115.629 69.302C103.274 69.302 93.258 79.3935 93.258 91.842C93.258 104.291 103.274 114.382 115.629 114.382Z",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M106.699 35.537L115.629 69.302M62.637 50.192L91.758 30.094M74.503 79.362L94.336 84.922",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrypto);
export default __webpack_public_path__ + "static/media/crypto.64f70c0885b9040e972a838d68790f97.svg";
export { ForwardRef as ReactComponent };